<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div class="flex justify-center text-center">
        <h4 id="title">{{ $t('assignments.modals.no_study_sets.title') }}</h4>
        <img :src="getIconUrl" />
        <el-row type="flex" justify="center">
            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
        <p class="desc">
          {{ $t('assignments.modals.no_study_sets.desc') }}
           </p>
          </el-col>
       
        </el-row>
        <el-row class="flex" justify="center">
          <primary-button class="action" ref="" @click.native="handleCreateStudySet">
            {{ $t('assignments.modals.no_study_sets.action') }}
          </primary-button>
        </el-row>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import { mapActions, mapGetters } from 'vuex'
import { format } from 'date-fns'

export default {
  props: {
    dateFormat: {
      type: String,
      default: 'MM/dd/yyyy'
    }
  },
  components: {
    Modal,
    PrimaryButton
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    }),
    getIconUrl() {
      return require(`@/assets/images/no-study-set.svg`)
    }
  },
  methods: {
    formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : '--'
    },
    handleCreateStudySet() {
      this.$emit('closed')
      this.$emit('create-study-set')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

#title {
  font-weight: 700;
  font-size: 30px;
  line-height: 45px;

  color: $black;
  margin: 0 auto;
  white-space: pre-wrap;
  
  margin-bottom: 16px !important;
}

#desc {
  font-weight: 600;
  font-size: 16px;
  line-height: 27px;

  color: $black;
  margin: 0 auto;
  white-space: pre-wrap;
  
  margin-top: 26px !important;
}

.elsa-button.action,
.elsa-button.action:hover {
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 32px;
  margin-left: auto;
}

::v-deep {
  .el-dialog.elsa-modal {
    width: 720px;
    .el-dialog__header,
    .el-dialog__body {
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      padding: 0px 32px 32px 32px;
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
</style>
